module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter TableOfContents"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Contents")])])]), _c('div', {
    staticClass: "block list-toc",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/a9781847677099_chapter_01#rw-title-block_127430-00001"
    }
  }, [_vm._v("Hope")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_02#rw-title-block_127431-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Happening")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_03#rw-title-block_127432-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Castle Terrace Car Park")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_04#rw-title-block_127433-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reanimation")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_05#rw-title-block_127434-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bez")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_06#rw-title-block_127435-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There is a Light that Never Goes Out")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_07#rw-title-block_127436-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This is My Story, This is My Song")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_08#rw-title-block_127437-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victims")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_09#rw-title-block_127438-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boxroom")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_10#rw-title-block_127439-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destination Anywhere")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_11#rw-title-block_127440-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meat")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_chapter_12#rw-title-block_127440-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Laura Hird")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_abouttheauthor#rw-title-block_127442-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line"
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('span', {
    attrs: {
      "href": "#/a9781847677099_insertedcopyright#rw-title-block_127439-00001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79302883","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847677099_tableofcontents.vue
// module id = 66
// module chunks = 0